import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useAppState } from "../../../hooks/use-app-state";
import { QuotationPopupSetCustomerAlreadyHasPolicyPopupOpened } from "../../../redux/quotation-popup/actions/default";
import { QuotationPopupState } from "../../../redux/quotation-popup/state";

export const useCustomerAlreadyHasPolicyPopup = () => {
    const pageState = useAppState<QuotationPopupState>("quotationPopup");
    const dispatch = useDispatch();
    const close = useCallback(() => {
        dispatch(
            new QuotationPopupSetCustomerAlreadyHasPolicyPopupOpened(
                false
            ).create()
        );
    }, []);
    return {
        opened: pageState.customerAlreadyHasPolicyPopup?.opened,
        close,
    };
};
